<script setup lang="ts">
type ProgrammeContentBlock = NonNullable<ProgrammePage['content']>[number]

// The GraphQL query (queries/global/programme-page.ts) always resolves the
// relations, so narrow the generated unions to the documents themselves.
type ProgrammeTypeItemEntry = Extract<ProgrammeContentBlock, { blockType: 'programme-type-item' }> & {
  programmeType: ProgrammeType
  maskShape: MaskShape & { filename: string, url: string, width: number, height: number }
}

const props = defineProps<{
  data: ProgrammePage
}>()

const content = computed(() => (props.data.content ?? []) as ProgrammeTypeItemEntry[])

</script>

<template>
  <div class="contents">
    <div
      v-if="hasRichTextContent(props.data.description)"
      class="container-d px-1 my-3"
    >
      <core-rich-text
        :content="props.data.description"
      />
    </div>

    <core-fit-text-group>
      <ul class="gap-2 lg:columns-2 -mb-3 mx-1">
        <li v-for="(item, index) in content" :key="item.id ?? index">
          <site-link
            v-if="item.programmeType"
            :route-object="{
              name: 'programme-type',
              params: { type: item.programmeType.slug },
            }"
            class="block overflow-hidden relative group pb-3 pointer-events-none grid-margin"
            :style="marginStyle(item)"
          >
            <core-mask-shape-with-text
              v-if="item.maskShape"
              :mask-shape="item.maskShape"
              :text="item.programmeType.title"
              hover-color="var(--color--gray)"
            />

            <core-rich-text
              v-if="hasRichTextContent(item.description)"
              :content="item.description"
              class="mt-0_5 pointer-events-auto"
            />
          </site-link>
        </li>
      </ul>
    </core-fit-text-group>
  </div>
</template>
